// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__3TUfF","content":"Footer_content__lVXxo"};